// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetVillageListSummaryRequest,
  TGetVillageListSummaryModel,
  IMappers,
  TGetVillageListSummaryResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetVillageListSummaryResponseSchema } from '../../entities/entities/GetVillageListSummaryResponseSchema';
import type { IErrorResponseSchema } from '../../../../../shared/repositories/countryside-search/entities/schemas/ErrorResponseSchema';

export function createGetVillageListSummaryModel(
  parameters: TGetVillageListSummaryRequest,
): TGetVillageListSummaryModel {
  return {
    v: 1,
    apiType: 'private',
    method: 'POST',
    microserviceName: 'countryside-search',
    pathApi: '/v1/get-village-list-summary/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetVillageListSummaryOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetVillageListSummaryRequest;
}

export async function fetchGetVillageListSummary<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetVillageListSummaryOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetVillageListSummaryResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetVillageListSummaryModel(parameters),
    config,
  )) as FetchResponse<TGetVillageListSummaryResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetVillageListSummaryResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetVillageListSummaryResponse>;
}
